import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { add, execute, getActivities, getDetail, getList, remove, update } from "services/workflow.service";

export const getWorkflows = createAsyncThunk("workflow/getWorkflows", async (params?: any) => {
  try {
    const response = await getList(params);
    return response;
  } catch (error) {
    return;
  }
});

export const getWorkflowDetail = createAsyncThunk("workflow/getWorkflowDetail", async (id: string) => {
  try {
    const response = await getDetail(id);
    return response;
  } catch (error) {
    return;
  }
});


export const executeWorkflow = createAsyncThunk("workflow/executeWorkflow", async (payload: any) => {
  try {
    const response = await execute({ workflowId: payload.workflowId, action: payload.action });
    toast.info(`Workflow ${payload?.action} successfully`, { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error(error as string, { autoClose: 3000 });
    throw error;
  }
});

export const createWorkflow = createAsyncThunk("workflow/createWorkflow", async (payload: any) => {
  try {
    const response = await add(payload);
    toast.success("Workflow created successfully", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error(error as string, { autoClose: 3000 });
    throw error;
  }
});

export const deleteWorkflow = createAsyncThunk("workflow/deleteWorkflow", async (id: string) => {
  try {
    const response = await remove(id);
    toast.success("Workflow deleted successfully", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error(error as string, { autoClose: 3000 });
    throw error;
  }
});

export const getListActivities = createAsyncThunk("workflow/getListActivities", async () => {
  try {
    const response = await getActivities();
    return response;
  } catch (error) {
    toast.error(error as string, { autoClose: 3000 });
    throw error;
  }
});

export const updateWorkflow = createAsyncThunk("workflow/updateWorkflow", async (payload: any, { dispatch }) => {
  try {
    const response = await update(payload.id, payload);
    dispatch(getWorkflowDetail(payload.id));
    toast.success("Workflow updated successfully", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error(error as string, { autoClose: 3000 });
    throw error;
  }
});